export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[960px] mx-auto text-center">
          <span className="inline-block px-3 py-1 bg-primary-100/70 text-primary-700 text-xs font-medium rounded-full mb-4">
            关于我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-6">
            丫丫影院 — 你的私人影视宝库
          </h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[720px] mx-auto space-y-4">
            <p>
              丫丫影院是一个专注于提供<strong>最新电影不缓冲</strong>和<strong>最新电视剧流畅</strong>观看体验的在线影视平台。我们深知观影过程中卡顿和缓冲带来的困扰，因此采用先进的智能加速与分布式传输技术，确保每一位用户都能享受<strong>不缓冲在线看</strong>的顺畅体验。
            </p>
            <p>
              平台收录超过20000部<strong>最新影视</strong>作品，涵盖动作、喜剧、爱情、科幻、动漫、纪录片等多种类型。我们坚持<strong>高清免费</strong>的理念，所有内容均支持多清晰度选择，搭配<strong>流畅播放</strong>引擎，无论电脑还是手机都能轻松<strong>在线观看</strong>。团队每日监测各大平台<strong>最新更新</strong>，确保热门<strong>电视剧</strong>和<strong>电影</strong>资源第一时间上线。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}